
<ng-template ssMobileToolbarContent>
    <div class="flex-row flex--justify-between flex--align-center flex-1">
        <h5 class="mat-headline-5 primary-contrast-text">{{'ss-routes.users' | translate}}</h5>
        <button
            mat-icon-button
            (click)="showSearchSubject.next(!showSearchSubject.value)"
        >
            <mat-icon class="primary-contrast-text">search</mat-icon>
        </button>

    </div>

</ng-template>


<ng-template    #actionsTemplate let-element="element" >

    <button *ngIf="!element.delete" color="warn" mat-icon-button (click)="deleteUser(element);$event.stopPropagation()">
        <mat-icon>delete</mat-icon>
    </button>

</ng-template>

<ng-template   #statusCellTemplate let-element="element">
    <div class="flex-row gap-small flex--align-center">
        <ng-container *ngIf="element.delete">
            <mat-icon class="data-grid-small-icon" color="warn">warning</mat-icon>
            <span class="error-text">{{'ss-entities.user.status.delete' | translate}}</span>
        </ng-container>

        <ng-container *ngIf="!element.active && !element.delete">
            <mat-icon class="data-grid-small-icon" >warning</mat-icon>
            {{'ss-entities.user.status.inactive' | translate}}
        </ng-container>


        <ng-container *ngIf="element.active && !element.delete" class="error-text">
            <mat-icon class="data-grid-small-icon" color="primary">check</mat-icon>
            <span class="primary-text">{{'ss-entities.user.status.active' | translate}}</span>
        </ng-container>
    </div>
</ng-template>


<ng-template #toolbarTemplate>

    <div class="display-block full-width" ssCoreLoaderOutlet [keys]="['user.import']">
        <ng-container *ngIf="isDesignerLoginUserPassword">
          <button     *ngIf="!(isSmallerScreenObs | async);else iconBtn"
                      mat-raised-button
                      color="primary"
                      (click)="routeToNewUser()"
          >
            <mat-icon>add</mat-icon>{{ 'ss-entities.user.new' | translate }}
          </button>

          <ng-template #iconBtn>

            <button mat-raised-button
                    color="primary"
                    class="full-width "
                    (click)="routeToNewUser()"
            >
              <mat-icon>add</mat-icon>
              {{ 'ss-entities.user.new' | translate }}
            </button>
          </ng-template>
        </ng-container>

      <ng-container *ngIf="!isDesignerLoginUserPassword">
        <button     *ngIf="!(isSmallerScreenObs | async);else iconBtn"
                    mat-raised-button
                    color="primary"
                    (click)="importUsers()"
        >
          <mat-icon>import_contacts</mat-icon>{{ 'ss-entities.user.import-users' | translate }}
        </button>

        <ng-template #iconBtn>

          <button mat-raised-button
                  color="primary"
                  class="full-width "
                  (click)="importUsers()"
          >
            <mat-icon>import_contacts</mat-icon>
            {{ 'ss-entities.user.import-users' | translate }}
          </button>
        </ng-template>
      </ng-container>

    </div>
</ng-template>

<ss-data-grid
    #gridRef
    class="display-block full-height"
    gridTitle="ss-routes.users"
    [showSearch]="showSearchSubject | async"
    [columns]="columns"
    [loadFn]="load"
    [actionsTemplate]="actionsTemplate"
    [cellTemplates]="{status:statusCellTemplate}"
    (rowClick)="routeToUser($event)"
    [toolbarTemplate]="toolbarTemplate"
    [customizeRow]="customizeRow"
>


</ss-data-grid>
